<template>
  <h-inspection-page title="4M1E变更申请明细" @inspection-update="inspectionUpdate" :smartBack="true" class="changeManagementDetail">
    <form-header title="4M1E变更申请明细" title-width="8">
      <template #title>
        <h-p align="left" title="单号" style="margin-left: 10px;">
          <span style="padding-left:10px">{{ searchData.changeId }}</span>
        </h-p>
      </template>
      <template #body>
        <tr>
          <report-td title="供应商代码" colspan="4:4">{{ searchData.vcode }}</report-td>
          <report-td title="供应商名称" colspan="4:4">{{ searchData.vname }}</report-td>
          <report-td title="变更申请日期" colspan="4:4">{{ time(searchData.applydate, 3) }}</report-td>
        </tr>
        <tr>
          <report-td title="变更名称" colspan="4:4">{{ searchData.changename }}</report-td>
          <report-td title="变更类别" colspan="4:4">{{ searchData.changetype }}</report-td>
          <report-td title="物料号" colspan="4:4">{{ searchData.materialcode }}</report-td>
        </tr>
        <tr>
          <report-td title="物料名称" colspan="4:4">{{ searchData.materialname }}</report-td>
          <report-td title="物料类别" colspan="4:4">{{ searchData.materialtype }}</report-td>
          <report-td title="适用产品线" colspan="4:4">{{ searchData.plname }}</report-td>
        </tr>
        <tr>
          <report-td title="供货互联工厂" colspan="4:4">{{ searchData.supplyfactory }}</report-td>
          <report-td title="申请验证互联工厂" colspan="4:4">{{ searchData.checkfactory }}</report-td>
          <report-td title="期望变更日期" colspan="4:4">{{ time(searchData.hopedate, 3) }}</report-td>
        </tr>
        <tr>
          <report-td title="库存数量" colspan="4:4">{{ searchData.inventoryAmounts }}</report-td>
          <report-td title="库存消化完成时间" colspan="4:4">{{ time(searchData.inventoryCompletionTime, 3) }}</report-td>
          <report-td title="是否影响成本" colspan="4:4">
            <span v-if="searchData.isimpactcost === 0">否</span>
            <span v-if="searchData.isimpactcost === 1">是</span>
          </report-td>
        </tr>
        <tr>
          <report-td title="影响成本" colspan="4:4">{{ searchData.impactcost }}</report-td>
          <report-td title="变更内容" colspan="4:12">{{ searchData.changecontent }}</report-td>
        </tr>
        <tr>
          <report-td title="附件" colspan="4::24">
            <div style="color: #165dff; font-size: 14px; cursor: pointer" @click="handleFile(searchData.filename, searchData.fileuuid)">
              {{ searchData.filename }}
            </div>
          </report-td>
        </tr>
        <h-tr>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;初审记录</h-tr>
        <tr style="height:44px;font-size:14px;color:#666;border-left:1px solid #ccc;border-right:1px solid #ccc;background: #FAFAFA;text-align:center;">
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">审核方</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">工号</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">姓名</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">时间</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">状态</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">意见</td>
        </tr>
        <!-- sqe -->
        <tr style="height:44px;font-size:14px;color:#666;border-left:1px solid #ccc;border-right:1px solid #ccc;background: #FFF;text-align:center;">
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">SQE初审</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> {{ time(searchData.sqeDate, 3) }} </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">
            <span v-if="searchData.sqesta === 0">未处理</span>
            <span v-if="searchData.sqesta === 1">通过</span>
            <span v-if="searchData.sqesta === 2">驳回</span>
          </td>
          <td class="reason_style" colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">{{ searchData.sqereason }}</td>
        </tr>
        <!-- 负责人 -->
        <tr style="height:44px;font-size:14px;color:#666;border-left:1px solid #ccc;border-right:1px solid #ccc;background: #FFF;text-align:center;">
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">SQE负责人审核</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">{{ time(searchData.sqeLeaderTime, 3) }}</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">
            <span v-if="searchData.sqeLeaderStatus === 'N'">未处理</span>
            <span v-if="searchData.sqeLeaderStatus === 'P'">通过</span>
            <span v-if="searchData.sqeLeaderStatus === 'F'">驳回</span>
          </td>
          <td class="reason_style" colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">{{ searchData.sqeLeaderOpinion }}</td>
        </tr>
        <h-tr>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;校核记录</h-tr>
        <!-- 开发 -->
        <tr style="height:44px;font-size:14px;color:#666;border-left:1px solid #ccc;border-right:1px solid #ccc;background: #FFF;text-align:center;">
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">开发校核</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">
            <span v-if="searchData.devsta === 0">未处理</span>
            <span v-if="searchData.devsta === 1">通过</span>
            <span v-if="searchData.devsta === 2">驳回</span>
          </td>
          <td class="reason_style" colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">{{ searchData.devReason }}</td>
        </tr>
        <!-- 口碑 -->
        <tr style="height:44px;font-size:14px;color:#666;border-left:1px solid #ccc;border-right:1px solid #ccc;background: #FFF;text-align:center;">
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">口碑校核</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">
            <span v-if="searchData.praisesta === 0">未处理</span>
            <span v-if="searchData.praisesta === 1">通过</span>
            <span v-if="searchData.praisesta === 2">驳回</span>
          </td>
          <td class="reason_style" colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">{{ searchData.praiseReason }}</td>
        </tr>
        <tr
          style="height:44px;font-size:14px;color:#666;border-left:1px solid #ccc;border-right:1px solid #ccc;background: #FFF;text-align:center;">
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">工厂校核</td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;"> -- </td>
          <td colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">
            <span v-if="searchData.factorysta === 0">未处理</span>
            <span v-if="searchData.factorysta === 1">通过</span>
            <span v-if="searchData.factorysta === 2">驳回</span>
          </td>
          <td class="reason_style" colspan="4" style="border-bottom: 1px solid #ccc;border-right: 1px solid #ccc;">{{ searchData.facReason }}</td>
        </tr>
        <h-tr>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;模块验证信息</h-tr>
        <tr>
          <report-td title="是否需要模块验证" colspan="4:4">
            <span v-if="searchData.moduleVerificationStatus === 0">否</span>
            <span v-if="searchData.moduleVerificationStatus === 1">是</span>
          </report-td>
          <report-td title="模块验证内容" colspan="4:4">{{ searchData.moduleVerificationContent }}</report-td>
          <report-td title="是否需要产品验证" colspan="4:4">
            <span v-if="searchData.productVerificationStatus === 0">否</span>
            <span v-if="searchData.productVerificationStatus === 1">是</span>
          </report-td>
        </tr>
        <tr>
          <report-td title="样品检验结果" colspan="4:4">
            <span v-if="searchData.sampleCheckResult === 'N'">无需验证</span>
            <span v-if="searchData.sampleCheckResult === 'Y'">待验证</span>
            <span v-if="searchData.sampleCheckResult === 'P'">合格</span>
            <span v-if="searchData.sampleCheckResult === 'F'">不合格</span>
          </report-td>
          <report-td title="小批验证结果" colspan="4:4">
            <span v-if="searchData.smallBatchVerificationResult === 'N'">无需验证</span>
            <span v-if="searchData.smallBatchVerificationResult === 'Y'">待验证</span>
            <span v-if="searchData.smallBatchVerificationResult === 'P'">合格</span>
            <span v-if="searchData.smallBatchVerificationResult === 'F'">不合格</span>
          </report-td>
          <report-td title="开发产品验证结果" colspan="4:4">
            <span v-if="searchData.devProductVerificationResult === 'N'">无需验证</span>
            <span v-if="searchData.devProductVerificationResult === 'Y'">待验证</span>
            <span v-if="searchData.devProductVerificationResult === 'P'">合格</span>
            <span v-if="searchData.devProductVerificationResult === 'F'">不合格</span>
          </report-td>
        </tr>
        <tr>
          <report-td title="开发产品验证附件" colspan="4:4">
            <div style="color: #165dff; font-size: 14px; cursor: pointer" @click="handleFile(searchData.devUploadFileName, searchData.devUploadFileUuid)">
              {{ searchData.devUploadFileName }}
            </div>
          </report-td>
          <report-td title="最终结论" colspan="4:4">
            <span v-if="searchData.finalResult === 'Y'">可变更</span>
            <span v-if="searchData.finalResult === 'N'">不可变更</span>
          </report-td>
          <report-td title="有效性" colspan="4:4">
            <span v-if="searchData.validStatus === 'Y'">有效</span>
            <span v-if="searchData.validStatus === 'N'">无效</span>
          </report-td>
        </tr>
      </template>
    </form-header>
    <div class="center_h-tr_FFF">
      <h-button @click="smartBackFun()" size="big" type="default">返回</h-button>
    </div>
  </h-inspection-page>
</template>
<script>
export default {
  data() {
    return {
      searchData: {},
      isIceFlag: false
    };
  },
  methods: {
    smartBackFun() {
      this.$router.back()
    },
    handleFile(name, url) {
      window.open('https://sqm.haier.net/readFile/newproduct/' + url);
    },
    /**
     * 请求数据 function
     */
    searchList() {
      this.$http({
        method: 'get',
        url: '/base/changeManagementOld/getManageInfo',
        headers: { 'content-type': 'application/json' },
        params: { id: this.$route.query.rejectsId }
      })
        .then(res => {
          console.log(res, '详情数据');
          this.searchData = res.data?.data;
          this.praiseAuditList = res.data.data.praiseAuditList;
          this.factoryAuditList = res.data.data.factoryAuditList;
          this.devAuditList = res.data.data.devAuditList;
          this.searchData.plName == '冰箱' || this.searchData.plName == '冷柜' || this.searchData.plName == '家用空调'
            ? (this.isIceFlag = true)
            : (this.isIceFlag = false);
        })
        .catch(err => {
          this.error('查询数据失败' + this.errorDispose(err.response.data || err.response || err));
        });
    },
    // fileDownload(url, name) {
    //   //新老路径-下载方法
    //   if (url.includes('http')) {
    //     let _down = name.split('.')[1];
    //     if (_down == 'pdf' || _down == 'jpeg' || _down == 'jpg' || _down == 'png') {
    //       window.open(url, '_blank');
    //     } else {
    //       let pathUrl = '/tosqmfordown' + url.split('.net')[1];
    //       this.startLoading('文件下载中...');
    //       this.httpFile(
    //         {
    //           method: 'get',
    //           url: pathUrl,
    //           headers: { 'content-type': 'application/json' }
    //         },
    //         name
    //       );
    //     }
    //   } else {
    //     this.startLoading('文件下载中...');
    //     this.httpFile(
    //       {
    //         method: 'get',
    //         url: '/unload/downLoadFileNewFtp',
    //         headers: { 'content-type': 'application/json' },
    //         params: { filePath: url }
    //       },
    //       name
    //     );
    //   }
    // }
  },
  mounted() {
    this.searchList();
    this.changeHeight();
  },
  updated() {
    this.changeHeight();
  },
  // 通过路由守卫改变参数，对原始页面代码改动小，推荐使用。注意：参数别漏了。
  beforeRouteEnter: (to, form, next) => {
    if (to.query.source || to.query.hmqm_source) {
      console.log('beforeRouteEnter======>', to);
      if (to.query.hasChangeQuery) {
        next();
      } else {
        next({
          path: to.path,
          query: {
            ...to.query,
            name: to.query.hmqm_name || to.query.name,
            nickName: to.query.hmqm_nickName || to.query.nickName,
            rejectsId: to.query.hmqm_rejectsId || to.query.rejectsId,
            mark: to.query.hmqm_mark || to.query.mark,
            hasChangeQuery: true,
            flag: undefined
          }
        });
      }
    } else {
      next();
    }
  }
};
</script>
<style lang="scss">
.changeManagementDetail {
  .haier-table {
    overflow: hidden;
  }
}
.haier-form-header {
  padding: 0 !important;
}
</style>
<style scoped>
.haier-form-header {
  padding: 0 !important;
}
.haier-table-header--right {
  width: calc(100% / 3) !important;
}

.haier-inspection-header .haier-table .haier-table-header .haier-table-header--right {
  width: calc(100% / 3) !important;
}

.height80_style {
  height: 80px;
}

.height80_style .haier-td {
  vertical-align: baseline;
  padding-top: 10px;
}

.center_h-tr > td {
  text-align: center !important;
}

.center_h-tr_FFF {
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_style {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reason_style:hover {
  white-space: normal;
  overflow: hidden;
  word-wrap: break-word;
}

.haier-table-header--right {
  white-space: nowrap;
}

.title_right {
  height: 40px;
  line-height: 40px;
  border-right: 0;
  padding-left: 10px;
}

.title_right td {
  border-bottom: 0 !important;
  border-right: 0 !important;
}
</style>
